import { render } from "./BlockDadosComplementares.vue?vue&type=template&id=10f7e85f"
import script from "./BlockDadosComplementares.vue?vue&type=script&lang=js"
export * from "./BlockDadosComplementares.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockDadosComplementares.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10f7e85f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10f7e85f', __exports__)) {
    console.log('reload')
    api.reload('10f7e85f', __exports__)
  }
  
  module.hot.accept("./BlockDadosComplementares.vue?vue&type=template&id=10f7e85f", () => {
    console.log('re-render')
    api.rerender('10f7e85f', render)
  })

}


export default __exports__